import styled from "@emotion/styled";

export const CustomQuoteHeaderWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	gap: "8px",
	backgroundColor: theme.palette.grey[100],
	color: theme.project.colors.fontColors.main
}));

export const CustomQuoteHeaderRow = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "8px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start"
	}
}));

export const CustomQuoteStatusRow = styled(CustomQuoteHeaderRow)(({ theme }) => ({
	padding: "4px 0px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "row",
		alignItems: "flex-start"
	}
}));

export const CustomQuoteDesignerLabel = styled.span(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.secondary
}));

export const CustomQuoteHeaderRowWide = styled(CustomQuoteHeaderRow)(({ theme }) => ({
	justifyContent: "space-between"
}));

export const CustomQuoteHeaderDesignerUpdatedRow = styled(CustomQuoteHeaderRowWide)(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		flexDirection: "column-reverse"
	}
}));

export const CustomQuoteHeaderDesignerRequestedBy = styled(CustomQuoteHeaderRowWide)(({ theme }) => ({
	div: {
		"span:last-of-type": {
			...theme.project.typography.body.body2
		},
		display: "flex",
		alignItems: "center",
		gap: "4px"
	}
}));

export const CustomQuoteCommentWrapper = styled(CustomQuoteHeaderRowWide)(({ theme }) => ({
	padding: "8px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	border: theme.project.borders.presets.thinOutline,
	alignItems: "center",
	"> div": {
		...theme.project.typography.body.body2,
		display: "flex",
		flexDirection: "column",
		gap: "8px",
		minWidth: 0,
		flex: 1,
		overflow: "hidden"
	},
	[theme.breakpoints.down("md")]: {
		alignItems: "flex-start",
		"> div": {
			width: "100%",
			maxWidth: "100%"
		},
		".MuiButton-root": {
			width: "100%",
			flexShrink: 0
		}
	}
}));

export const CustomQuoteStatus = styled.div(({ theme }) => ({
	color: theme.project.colors.primaryColors.main
}));

export const HorizontalLine = styled.div(({ theme }) => ({
	borderTop: `1px solid ${theme.palette.divider}`, // Black @ 12% opacity, divider color
	width: "100%",
	height: 0
}));

export const LatestCommentContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column"
}));

export const LatestCommentHeader = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	marginBottom: "4px"
}));

export const LatestCommentContent = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main,
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
	maxWidth: "100%",
	span: {
		fontWeight: 600
	}
}));
